import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { DateFormat } from '../../models';

interface DateSingleItemProps {
  name: string;
  disabled?: boolean;
  size?: 'small' | 'default' | 'large';
  initialValue?: Moment | null;
  control: Control;
  placeholder?: string;
  allowClear?: boolean;
}

const parseMoment = (value: Moment | null | undefined): Moment | null => {
  if (value == null) return null;
  if (moment.isMoment(value)) return value;
  return null;
};

const DateSingleItem = ({ name, disabled, size, initialValue, control, placeholder, allowClear = false }: DateSingleItemProps) => (
  <Controller
    name={name}
    as={
      <DatePicker
        id={name}
        name={name}
        disabled={disabled}
        format={DateFormat.YYYY_MM_DD}
        size={size}
        placeholder={placeholder}
        style={{ width: '100%' }}
        popupStyle={{ borderRadius: '20px' }}
        allowClear={allowClear}
      />
    }
    control={control}
    defaultValue={parseMoment(initialValue)}
  />
);

export default DateSingleItem;
